module.exports = __webpack_public_path__ + "img/_back.7f11395b.svg";